import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import { useDropzone } from "react-dropzone"
import { FaImages } from "react-icons/fa"
import { IoDocuments } from "react-icons/io5"

// ----------------------------------------------------------------------------

function ImagesUploadDropzone(props) {
    // -------------------------------------
    // Props destructuring
    // -------------------------------------

    const { type, onUpload, name } = props

    // -------------------------------------
    // Hooks (e.g. useState, useMemo ...)
    // -------------------------------------

    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        onDrop,
        accept: type === "images" ? ".jpeg,.png, .jpg" : ".pdf",
    })

    // -------------------------------------
    // Effects
    // -------------------------------------

    // -------------------------------------
    // Component functions
    // -------------------------------------

    function onDrop(acceptedFiles) {
        handleUploadChange(acceptedFiles)
    }

    function handleUploadChange(acceptedFiles) {
        onUpload && onUpload(acceptedFiles)
    }

    function renderIcon() {
        switch (type) {
            case "images": {
                return <FaImages className="icon" size={50} />
            }

            case "documents": {
                return <IoDocuments className="icon" size={50} />
            }

            default: {
                return <FaImages className="icon" size={50} />
            }
        }
    }
    // -------------------------------------
    // Component local variables
    // -------------------------------------

    const containerClassName = `${isDragActive ? " drag-active" : ""}`

    return (
        <div
            className={`${props.className}${containerClassName}`}
            {...getRootProps()}
        >
            <input {...getInputProps()} name={name} />

            {renderIcon()}

            <p>
                Trascina i file o clicca su quest&apos;area
                <br /> per effettuare <b>l&apos;upload</b>
            </p>
        </div>
    )
}

// ----------------------------------------------------------------------------
// Component PropTypes and default props
// ----------------------------------------------------------------------------

ImagesUploadDropzone.propTypes = {
    className: PropTypes.string.isRequired,
    type: PropTypes.oneOf(["images", "documents"]),
    onUpload: PropTypes.func,
    forbidMany: PropTypes.bool,
    name: PropTypes.string,
}

ImagesUploadDropzone.defaultProps = {
    documentName: "",
    type: "images",
}

// ----------------------------------------------------------------------------

const StyledImagesUploadDropzone = styled(ImagesUploadDropzone)`
    & {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        padding: 20px;
        box-sizing: border-box;
        min-width: 300px;
        width: 100%;
        height: 200px;

        border: 2px dashed #9aa8c5;
        border-radius: 10px;

        background-color: ${(props) =>
            props?.theme?.colors?.secondaryBackgroundColor};

        cursor: pointer;
        z-index: 1;

        &.drag-active {
            background-color: ${(props) => props?.theme?.colors?.dropzoneHover};
        }

        label {
            text-align: center;
            font-weight: bold;
            font-size: 18px;
            color: ${(props) => props?.theme?.colors?.dropzoneTextColor};
        }

        p {
            margin-top: 10px;
            text-align: center;
            font-weight: 400;
            color: ${(props) => props?.theme?.colors?.dropzoneTextColor};
        }

        .icon {
            color: ${(props) => props?.theme?.colors?.dropzoneTextColor};
        }
    }
`
// ----------------------------------------------------------------------------

export default StyledImagesUploadDropzone
